module.exports = __webpack_public_path__ + "img/velans-tf-2.173dbb9.jpg";